import { createSlice } from "@reduxjs/toolkit";
import { BROWSE_LOG_BARRIER } from "./constant";

export const barrierSlice = createSlice({
  name: BROWSE_LOG_BARRIER,
  initialState: {
    barrierLog: {
      filterData: {
        direction: {},
        open_type: {},
        stations: [],
        station_gates: [],
        recognize_type: {},
        camera_type: {}
      },
      log: {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      },
      humanLog: {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      },
      
    },
    barrierCamera: {
      camera: {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      },
      deleteRes: {
        message: "Xóa camera barrier thành công."
      },
      station: {
        data: []
      },
      gate: {
        data: []
      }
    },
    barrierDashboard: {
      filterData: {
        directions: [],
        direction: {},
        stations: [],
        recognize_type: {},
        recognize_types: []
      },
      dashboard: {
        data: {}
      }
    },
    barrierGate: {
      gate: {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      },
      deleteRes: {
        message: "Xóa cổng thành công."
      },
      station: {
        data: []
      }
    },
  },
  reducers: {
    // Log
    getLogFilterDataSucceed(state, action) {
      state.barrierLog.filterData = action.payload;
      return state;
    },
    getLogFilterDataFailed(state) {
      state.barrierLog.filterData = {
        direction: {},
        open_type: {},
        stations: [],
        station_gates: [],
        recognize_type: {},
        camera_type: {}
      };
      return state;
    },
    getHumanLogDataSucceed(state, action) {
      state.barrierLog.humanLog = action.payload;
      return state;
    },
    getHumanLogDataFailed(state) {
      state.barrierLog.humanLog = {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      };
      return state;
    },
    getLogDataSucceed(state, action) {
      state.barrierLog.log = action.payload;
      return state;
    },
    getLogDataFailed(state) {
      state.barrierLog.log = {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      };
      return state;
    },
    // Camera
    getCameraDataSucceed(state, action) {
      state.barrierCamera.camera = action.payload;
      return state;
    },
    getCameraDataFailed(state) {
      state.barrierCamera.camera = {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      };
      return state;
    },
    deleteCameraSucceed(state, action) {
      state.barrierCamera.deleteRes = action.payload;
      return state;
    },
    deleteCameraFailed(state) {
      state.barrierCamera.deleteRes = {
        message: "Xóa camera barrier thất bại."
      };
      return state;
    },

    // Station
    getStationDataSucceed(state, action) {
      state.barrierCamera.station = action.payload;
      return state;
    },
    getStationDataFailed(state) {
      state.barrierCamera.station = {
        data: [],
      };
      return state;
    },

    // Gate
    getGateDataSucceed(state, action) {
      state.barrierGate.gate = action.payload;
      return state;
    },
    getGateDataFailed(state) {
      state.barrierGate.gate = {
        data: [],
        page: 0,
        size: 10,
        total_elements: 0,
        total_pages: 0
      };
      return state;
    },

    // Dashboard
    getDashboardDataSucceed(state, action) {
      state.barrierDashboard.dashboard = action.payload;
      return state;
    },
    getDashboardDataFailed(state) {
      state.barrierDashboard.dashboard = {
        data: {}
      };
      return state;
    },
    getFilterDashboardDataSucceed(state, action) {
      state.barrierDashboard.filterData = action.payload;
      return state;
    },
    getFilterDashboardDataFailed(state) {
      state.barrierDashboard.filterData = {
        directions: [],
        direction: {},
        stations: [],
        recognize_type: {},
        recognize_types: []
      };
      return state;
    }
  }
});

export const barrierActions = barrierSlice.actions;
export const barrierReducers = barrierSlice.reducer;
